module.exports = __webpack_public_path__ + "img/rongrong_20210901114752.b3e0805f.png";